define("shared/helpers/linkify-html", ["exports", "@ember/component/helper", "@ember/template", "shared/utils/find-link-segments", "shared/utils/sanitize-html"], function (_exports, _helper, _template, _findLinkSegments, _sanitizeHtml) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"@ember/template",0,"shared/utils/find-link-segments",0,"shared/utils/sanitize-html"eaimeta@70e063a35619d71f
  const ANCHOR_TAG = 'A';

  // nodeType over instanceof: DOMParser builds its nodes in a separate document, so they
  // aren't guaranteed to be instances of the globals we'd compare against.
  const isText = node => node.nodeType === Node.TEXT_NODE;
  const isElement = node => node.nodeType === Node.ELEMENT_NODE;
  const linkifyTextNode = (doc, node) => {
    const segments = (0, _findLinkSegments.default)(node.data);
    if (!segments.some(segment => segment.kind === 'link')) {
      return;
    }
    const fragment = doc.createDocumentFragment();
    for (const segment of segments) {
      if (segment.kind === 'link') {
        const anchor = doc.createElement('a');
        anchor.setAttribute('href', segment.href);
        anchor.setAttribute('target', '_blank');
        anchor.setAttribute('rel', 'noopener noreferrer');
        anchor.textContent = segment.text;
        fragment.append(anchor);
      } else {
        fragment.append(doc.createTextNode(segment.value));
      }
    }
    node.parentNode?.replaceChild(fragment, node);
  };
  const walk = (doc, node, insideAnchor) => {
    // Snapshot the list, since replacing a text node mutates the live childNodes underneath us
    const children = Array.from(node.childNodes);
    for (const child of children) {
      if (isText(child)) {
        // A URL already inside an <a> is someone else's link; don't nest another one in it
        if (!insideAnchor) {
          linkifyTextNode(doc, child);
        }
      } else if (isElement(child)) {
        walk(doc, child, insideAnchor || child.tagName === ANCHOR_TAG);
      }
    }
  };

  /**
   * Renders an HTML string with its bare URLs wrapped in anchors that open in a new tab, then
   * sanitizes the result. Use this instead of `{{html-safe}}` for user-authored HTML: feedback
   * and comment bodies come out of Later Influence's Froala editors with the `url` plugin off,
   * so a typed URL is stored as plaintext inside otherwise-formatted markup, and nothing on the
   * write path filters what gets stored.
   *
   * The plain-text sibling is `{{linkify-text}}`; both share the URL rules in
   * `shared/utils/find-link-segments`.
   *
   * Parsing before sanitizing is safe: DOMParser builds a detached document, so no script runs
   * and no resource is fetched, and the spliced anchors only ever carry an http(s) href.
   */
  const linkifyHtmlHelperFn = _ref => {
    let [html] = _ref;
    const source = html ?? '';
    if (!source) {
      return (0, _template.htmlSafe)('');
    }
    const doc = new DOMParser().parseFromString(source, 'text/html');
    walk(doc, doc.body, false);
    return (0, _template.htmlSafe)((0, _sanitizeHtml.default)(doc.body.innerHTML));
  };
  const linkifyHtmlHelper = (0, _helper.helper)(linkifyHtmlHelperFn);
  var _default = _exports.default = linkifyHtmlHelper;
});